import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustBadges = () => {
  const badges = [
    {
      icon: 'Shield',
      title: 'Безопасность данных',
      description: 'Шифрование AES-256 и соответствие GDPR'
    },
    {
      icon: 'Lock',
      title: 'Защита платежей',
      description: 'PCI DSS сертификация для безопасных транзакций'
    },
    {
      icon: 'Award',
      title: 'ISO 27001',
      description: 'Международный стандарт информационной безопасности'
    },
    {
      icon: 'CheckCircle',
      title: 'Гарантия возврата',
      description: '30 дней гарантии возврата средств'
    }
  ];

  const stats = [
    { value: '10 000+', label: 'Активных клиентов' },
    { value: '99.9%', label: 'Uptime гарантия' },
    { value: '24/7', label: 'Техподдержка' },
    { value: '50M+', label: 'Обработано сообщений' }
  ];

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {badges?.map((badge, index) => (
          <div
            key={index}
            className="bg-card rounded-xl p-6 border border-border hover:border-accent/50 transition-all duration-200 hover:shadow-lg"
          >
            <div className="w-12 h-12 bg-gradient-to-br from-accent/20 to-primary/20 rounded-xl flex items-center justify-center mb-4">
              <Icon name={badge?.icon} size={24} color="var(--color-accent)" />
            </div>
            <h4 className="font-headline font-semibold text-foreground mb-2">
              {badge?.title}
            </h4>
            <p className="text-sm text-muted-foreground">
              {badge?.description}
            </p>
          </div>
        ))}
      </div>
      <div className="bg-gradient-to-br from-primary to-secondary rounded-2xl p-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats?.map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-3xl lg:text-4xl font-bold text-white mb-2">
                {stat?.value}
              </p>
              <p className="text-sm text-white/80">
                {stat?.label}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-xl p-6 border border-border">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 bg-success/20 rounded-xl flex items-center justify-center flex-shrink-0">
              <Icon name="Sparkles" size={32} color="var(--color-success)" />
            </div>
            <div>
              <h4 className="font-headline font-semibold text-foreground mb-1">
                Специальное предложение для новых клиентов
              </h4>
              <p className="text-sm text-muted-foreground">
                Получите 20% скидку на первые 3 месяца при выборе годового плана
              </p>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="bg-gradient-to-r from-accent to-primary px-6 py-3 rounded-xl">
              <p className="text-white font-bold text-lg">
                Промокод: NEW2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustBadges;